module.exports = __webpack_public_path__ + "img/n5.8fb27f6f.png";